export const blockIconsActivitiesSportsScoreNew = (
	<span className='material-symbols-outlined'>sports_score</span>
);
